import { render, staticRenderFns } from "./Museums.vue?vue&type=template&id=1267af64&scoped=true"
import script from "./Museums.vue?vue&type=script&lang=js"
export * from "./Museums.vue?vue&type=script&lang=js"
import style0 from "./Museums.vue?vue&type=style&index=0&id=1267af64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1267af64",
  null
  
)

export default component.exports